import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Components
import { ActionButtons } from '../../components/ActionButtons';
import DataTable from '../../components/DataTable';

// Prime-React Components
import { confirmDialog } from 'primereact/confirmdialog';

// Constants
import {
  ACTION_TYPE,
  DEBOUNCE_TIMEOUT,
  INITIAL_PAGE_NUMBER,
  INITIAL_SIZE,
  TABLE_NAME
} from '../../constants/common';
import { EMAIL_TEMPLATES_COLUMNS } from '../../constants/tableColumns';

// Utils
import {
  deleteTemplate,
  getEmailTemplateById,
  getEmailTemplatesList
} from '../../redux/actions/emailTemplates';
import { debounce } from '../../utils/debounce';
import AddEditEmailTemplates from './AddEditEmailTemplates';

const EmailTemplates = () => {
  const dispatch = useDispatch();
  const { emailTemplate } = useSelector((state) => state);
  const [emailTemplateId, setEmailTemplateId] = useState(null);
  const [emailTemplatesList, setEmailTemplatesList] = useState([]);
  const [tableStates, setTableStates] = useState({
    searchValue: '',
    pageNumber: INITIAL_PAGE_NUMBER,
    size: INITIAL_SIZE,
    sortBy: 'DateModified',
    orderBy: 'desc'
  });

  const [visibleRight, setVisibleRight] = useState(false);
  const onToggleSidebar = (visiblity) => setVisibleRight(visiblity);

  useEffect(() => {
    dispatch(getEmailTemplatesList(tableStates));
  }, [
    dispatch,
    tableStates,
    emailTemplate?.isTemplateDeleted,
    emailTemplate?.isUpdated,
    emailTemplate?.isAdded
  ]);

  useEffect(() => {
    const modifiedTemplate = emailTemplate?.data?.map((ele) => {
      return {
        ...ele,
        Name: ele?.Title || '',
        Subject: ele?.Subject || '',
        action: (
          <div className="flex align-items-center">
            <ActionButtons onClick={(actionType, e) => handleRowActions(actionType, ele.ID, e)} />
          </div>
        )
      };
    });
    setEmailTemplatesList(modifiedTemplate);
  }, [emailTemplate]);

  const handlePagination = (pageNumber, size) =>
    setTableStates((prevState) => {
      return {
        ...prevState,
        pageNumber,
        size
      };
    });

  const handleSearch = (searchValue) => {
    setTableStates((prevState) => {
      return {
        ...prevState,
        searchValue
      };
    });
  };

  const handleRowActions = (actionType, rowId) => {
    if (actionType === ACTION_TYPE.EDIT) {
      onToggleSidebar(true);
      setEmailTemplateId(rowId);
      dispatch(getEmailTemplateById(rowId));
    } else if (actionType === ACTION_TYPE.DELETE) {
      confirmDialog({
        header: 'Delete',
        message: 'Are you sure you want to delete?',
        icon: 'pi pi-exclamation-triangle',
        accept: () => dispatch(deleteTemplate(rowId))
      });
    }
  };

  return (
    <>
      {visibleRight && (
        <AddEditEmailTemplates ID={emailTemplateId} onHide={onToggleSidebar} show={visibleRight} />
      )}
      <DataTable
        name={TABLE_NAME.EMAIL_TEMPLATES}
        searchPlaceHolder="Search by Title"
        columns={EMAIL_TEMPLATES_COLUMNS}
        data={emailTemplatesList}
        totalRecords={emailTemplate?.pagination?.totalRecords}
        onPagination={handlePagination}
        pageNumber={tableStates.pageNumber}
        pageSize={tableStates.size}
        onSearch={debounce(handleSearch, DEBOUNCE_TIMEOUT)}
      />
    </>
  );
};

export default EmailTemplates;
